import $ from 'jquery';
import gsap from 'gsap';

const lang = document.querySelector('.lang');
const menu = document.querySelector('.header_menu');
const hamb = document.querySelector('.header_hamb');
const tl = gsap.timeline({ paused: true });
const $hamb = $('.header_hamb');

const toggleState = (el, isMenu) => (state) => {
  el.classList.toggle('opened', state);
  if (isMenu) {
    $('body').toggleClass('overlay', state);
    if (state) {
      tl.play();
    } else {
      tl.reverse();
    }
  }
};

document.querySelector('.lang_button').addEventListener('click', () => {
  toggleState(lang)();
});

document.addEventListener('click', (e) => {
  if (e.target !== lang && !lang.contains(e.target)) toggleState(lang)(false);
  if (
    e.target !== menu &&
    !menu.contains(e.target) &&
    e.target !== hamb &&
    !hamb.contains(e.target)
  ) {
    toggleState(menu, true)(false);
    toggleState(hamb)(false);
  }
});

document.querySelector('.header_hamb').addEventListener('click', () => {
  toggleState(menu, true)(!$hamb.hasClass('opened'));
  toggleState(hamb)();
});

tl.to(
  '.header_hamb_line-top',
  {
    y: 3.5,
    duration: 0.2,
  },
  0
)
  .to('.header_hamb_line-bottom', { y: -3.5, duration: 0.2 }, 0)
  .to('.header_hamb', { rotate: 45, duration: 0.25 })
  .to(
    '.header_hamb_line-bottom',
    { transformOrigin: '50% 50%', rotate: 90, duration: 0.25 },
    '-=0.3'
  );

$hamb
  .on('mouseenter', () => {
    gsap.to('.header_hamb_line-top', { width: 27, duration: 0.25 });
  })
  .on('mouseleave', () => {
    if (!$hamb.hasClass('opened'))
      gsap.to('.header_hamb_line-top', { width: 22, duration: 0.25 });
  });
